import styled from 'styled-components';

export const Container = styled.div`
  .progress {
    color: #17549b;
    margin-top: 5%;
  }
`;
